import * as yup from "yup";

export const companyFormSteps = [
  {
    stepNo: 1,
    fullWidth: true,
    fields: [
      {
        name: "email",
        fieldId: "email",
        label: "Email address",
        type: "input-text",
        isRequired: true,
        size: 12,
      },
      {
        name: "name",
        fieldId: "name",
        label: "Company Name",
        type: "input-text",
        isRequired: true,
        size: 12,
      },
      {
        name: "phone",
        fieldId: "phone",
        label: "Phone",
        placeholder: "+38975123456",
        type: "input-text",
        isRequired: true,
        size: 12,
      },
    ],
  },
];

export const companyRegisterSchema = yup
  .object()
  .shape({
    email: yup.string("The email is not valid.").email("Please enter a valid email.").required("Please enter your email."),
    name: yup.string("The name is not valid.").trim().required("The name is required."),
    phone: yup.string("The phone is not valid.").trim().required("Please enter your phone.").matches(/^\+/, "Phone number must include country code (e.g., +389 for Macedonia)"),
  })
  .required();
